import React from 'react';

import { flagStyles } from '../settings';

const SvgFR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1752px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgFR;
